import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import i18n from "./i18n";
import "./index.css";
import LoadingMessage from "./components/pages/util/LoadingMessage";

i18n.init().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <Suspense
      fallback={
        <div className="flex items-center justify-center min-h-screen bg-white">
          <LoadingMessage />
        </div>
      }
    >
      <App />
    </Suspense>
  );
});
